import { createAsyncThunk } from '@reduxjs/toolkit';
import { contactService } from '../services/contact.service';
import { ContactFormPayload, ContactSubmission } from '../interface/contact.interface';
import axios from 'axios';

/**
 * Thunk to submit a contact form
 */
export const submitContactForm = createAsyncThunk<ContactSubmission, ContactFormPayload>(
  'contact/submit',
  async (payload, { rejectWithValue }) => {
    try {
      await contactService.submitContact(payload);
      return payload;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const data = error.response?.data as { message?: string; error?: string } | undefined;
        if (status === 429) {
          return rejectWithValue('Too many requests. Please try again later.');
        }
        return rejectWithValue(data?.message || data?.error || 'Failed to send your message. Please try again.');
      }
      return rejectWithValue('Failed to send your message. Please try again.');
    }
  }
);
